import { z } from 'zod';

import { commonSchemas } from '@project/schemas';

export const changePartnersPasswordSchema = z.object({
  password: commonSchemas.password,
});
